var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-main-content" },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showMainList,
              expression: "showMainList"
            }
          ],
          staticClass: "main-content",
          attrs: { type: "primary" }
        },
        [
          _c(
            "fcl-search-bar",
            {
              ref: "searchBar",
              attrs: {
                "show-currency": false,
                "is-manage-module": true,
                "show-schedule": false,
                "is-surcharge": true,
                filter: _vm.filter,
                "show-via": true,
                "is-cp": _vm.activeTabName === "cpList",
                "config-id": "SurchargeFCL"
              },
              on: {
                onLevelChanged: _vm.onLevelChanged,
                simSearchItemCallBack: _vm.toSimpleQuery,
                advSearchItemResetCallBack: _vm.toAdvancedQuery,
                reset: _vm.resetQuery
              }
            },
            [
              _vm.activeTabName === "cpList"
                ? _c(
                    "template",
                    { slot: "operations" },
                    [
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.role.editButton,
                              expression: "role.editButton"
                            }
                          ],
                          attrs: {
                            no: "onEditCP",
                            type: "success",
                            disabled: !this.cpSelectRow
                          },
                          on: {
                            click: function($event) {
                              return _vm.onEdit_CP()
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("Pricing.Edit")))]
                      ),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.role.deleteButton,
                              expression: "role.deleteButton"
                            }
                          ],
                          attrs: { no: "onDeleteCP", type: "danger" },
                          on: {
                            click: function($event) {
                              return _vm.onDelete_CP()
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("Pricing.Delete")))]
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.activeTabName !== "cpList"
                ? _c(
                    "template",
                    { slot: "operations" },
                    [
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.role.editButton,
                              expression: "role.editButton"
                            }
                          ],
                          attrs: {
                            no: "onEditPP",
                            type: "success",
                            disabled: !this.ppSelectRow
                          },
                          on: {
                            click: function($event) {
                              return _vm.onEdit_PP()
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("Pricing.Edit")))]
                      ),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.role.deleteButton,
                              expression: "role.deleteButton"
                            }
                          ],
                          attrs: { no: "onDeletePP", type: "danger" },
                          on: {
                            click: function($event) {
                              return _vm.onDelete_PP()
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("Pricing.Delete")))]
                      ),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.role.approveButton,
                              expression: "role.approveButton"
                            }
                          ],
                          attrs: {
                            no: "onApprovePP",
                            type: "primary",
                            disabled: !_vm.ppSelectLength
                          },
                          on: {
                            click: function($event) {
                              return _vm.onApprove_PP()
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("Pricing.Approve")))]
                      ),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.role.addButton,
                              expression: "role.addButton"
                            }
                          ],
                          attrs: { no: "onAddPP", type: "primary" },
                          on: {
                            click: function($event) {
                              return _vm.onAdd_PP()
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("Pricing.Add")))]
                      ),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.role.addButton,
                              expression: "role.addButton"
                            }
                          ],
                          attrs: { no: "onDownloadTemplate", type: "primary" },
                          on: {
                            click: function($event) {
                              return _vm.onDownloadTemplate()
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("Pricing.Template")))]
                      ),
                      _c(
                        "el-upload",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.role.addButton,
                              expression: "role.addButton"
                            }
                          ],
                          staticStyle: {
                            display: "inline-block",
                            "margin-left": "5px"
                          },
                          attrs: {
                            no: "saveSurchargeExcelFile",
                            action: _vm.URL.price.saveSurchargeExcelFile,
                            headers: { sessionId: _vm.sessionId },
                            "show-file-list": false,
                            accept: ".xls, .xlsx",
                            "before-upload": _vm.beforeUpload,
                            "on-success": _vm.uploadExcelSuccess,
                            data: {
                              currentOfficeId:
                                _vm.$store.getters.currentOfficeId
                            }
                          }
                        },
                        [
                          _c(
                            "el-button",
                            { attrs: { no: "import", type: "primary" } },
                            [_vm._v(_vm._s(_vm.$t("Pricing.Import")))]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            2
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "tabs-container" },
        [
          _c(
            "el-tabs",
            {
              ref: "tabs",
              staticStyle: { width: "100%" },
              attrs: { type: "card" },
              on: { "tab-click": _vm.handleTabClick },
              model: {
                value: _vm.activeTabName,
                callback: function($$v) {
                  _vm.activeTabName = $$v
                },
                expression: "activeTabName"
              }
            },
            [
              _c(
                "el-tab-pane",
                {
                  attrs: {
                    label: _vm.$t("Pricing.CurrentPrice"),
                    name: "cpList"
                  }
                },
                [
                  _c("surcharge-fcl-data-grid", {
                    ref: "cpList",
                    attrs: {
                      "config-module": "22080101",
                      "row-data": _vm.rowCpData,
                      "show-approve": true,
                      "show-cost": true,
                      "show-modify": true,
                      "show-create": true,
                      filter: _vm.filter,
                      "grid-options": _vm.cpGridOptions
                    },
                    on: { selectRowChange: _vm.selectRowChange }
                  })
                ],
                1
              ),
              _c(
                "el-tab-pane",
                {
                  attrs: {
                    label: _vm.$t("Pricing.PendingPrice"),
                    name: "ppList"
                  }
                },
                [
                  _c("surcharge-fcl-data-grid", {
                    ref: "ppList",
                    attrs: {
                      "config-module": "22080102",
                      "row-data": _vm.rowPpData,
                      "show-approve": false,
                      "show-modify": true,
                      "show-create": true,
                      "show-cost": true,
                      filter: _vm.filter,
                      "grid-options": _vm.ppGridOptions
                    },
                    on: { selectRowChange: _vm.selectRowChange }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            {
              staticStyle: {
                position: "absolute",
                left: "160px",
                margin: "10px"
              }
            },
            [_c("span", [_vm._v(_vm._s(_vm.globalMsg))])]
          )
        ],
        1
      ),
      _vm.surchargeFclFormDialog.visible
        ? _c("surcharge-fcl-form", {
            ref: "surchargeFclForm",
            attrs: {
              visible: _vm.surchargeFclFormDialog.visible,
              "source-price": _vm.surchargeFclFormDialog.sourcePrice,
              price: _vm.surchargeFclFormDialog.price,
              "is-new": _vm.surchargeFclFormDialog.isNew,
              "is-cp": this.activeTabName === "cpList"
            },
            on: {
              close: _vm.onsurchargeFclFormDialogClose,
              deleteCp: _vm.deleteCp,
              clearGrid: _vm.clearGrid
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }